export const BASE_URL = '/search'
export const REDUCER_INDEX = 'search_v2'
